module.exports = __webpack_public_path__ + "img/translate-six.f2910d60.png";